/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-04 10:03:45
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Button, Heading } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import empty from 'src/assets/images/filter-tree/empty-option.png';

import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = WithI18nProps;
// DONE
const NoWidgetFound = (props: Props): Component<Props> => {
  const { i18n } = props;

  return (
    <div className="BC-EmptySearch__RecommendationWidget">
      <img src={empty} alt={i18n.translate('AdminHTML.ProductRanking.NoProductRanking.imgAlt')} />
      <Heading>{i18n.translate(`AdminHTML.PredictiveBundle.noData_Label`)}</Heading>
      <p style={{ margin: '4px 0 24px', color: 'rgba(109, 113, 117, 1)' }}>
        {i18n.translate(`AdminHTML.PredictiveBundle.noData_Content`)}
      </p>
      <Button
        primary
        onClick={() => {
          history.push(routes.predictiveBundle.new());
        }}>
        {i18n.translate('AdminHTML.PredictiveBundle.Common.buttonAddOffer')}
      </Button>
      <div style={{ padding: '40px' }} />
    </div>
  );
};

export default withI18n()(NoWidgetFound);
